import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../../../hooks/useIsMobile';

interface BookSectionCardProps {
    title: string;
    children: React.ReactNode;
}

const BookSectionCard: React.FC<BookSectionCardProps> = ({ title, children }) => {
    const isMobile = useIsMobile();

    return (
        <div
            className={`bg-[#f8faf9] border border-[#e5ece8] flex flex-col ${
                isMobile
                    ? 'rounded-[20px] gap-4 pt-5 px-5 pb-4'
                    : 'rounded-[24px] gap-4 p-8'
            }`}
        >
            {/* 제목: 왼쪽 → 오른쪽 */}
            <motion.div
                className="flex items-center"
                style={{ gap: isMobile ? '14px' : '16px' }}
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.55, ease: "easeOut" }}
            >
                <div
                    className={`bg-[#19cf7a] rounded-full shrink-0 ${
                        isMobile ? 'w-[4px] h-[20px]' : 'w-[7px] h-10'
                    }`}
                />
                <span className={`font-bold text-black ${isMobile ? 'text-[20px]' : 'text-[32px]'}`}>
                    {title}
                </span>
            </motion.div>

            {/* 본문: 아래 → 위 */}
            <motion.div
                className={`font-namsan text-[#565659] ${
                    isMobile ? 'text-[15px] leading-[28px]' : 'text-[18px] leading-[1.8]'
                }`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.55, delay: 0.2, ease: "easeOut" }}
            >
                {children}
            </motion.div>
        </div>
    );
};

export default BookSectionCard;
